import { render, staticRenderFns } from "./reset-success.html?vue&type=template&id=645cb7a7&scoped=true&external"
import script from "./reset-success.js?vue&type=script&lang=js&external"
export * from "./reset-success.js?vue&type=script&lang=js&external"
import style0 from "./reset-success.scss?vue&type=style&index=0&id=645cb7a7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645cb7a7",
  null
  
)

export default component.exports